module fdm {
    export class ErrorHandlerController {
        public constructor(private msalAuthenticationService) {}

        logout = () => {
            this.msalAuthenticationService.logout();
        }
    }

    angular.module('fdm')
        .component('errorHandler', {
            controller: (ErrorHandlerController as any),
            templateUrl: ($stateParams: ng.ui.IStateParamsService) => {
                return '/app/src/errors/error-' + ($stateParams.errorCode ? $stateParams.errorCode : '500') + '.html'
            }
        });
}